import gql from 'graphql-tag'
export default gql`
  mutation removeOrganisation($token: String!, $id: Int!) {
    removeOrganisation(id: $id, token: $token)
  }
`
